export default "__VITE_ASSET__CtaODEmE__"